const poStaManageZh = {
  poStaManageLang: {
    电站管理: '电站管理',
    创建电站: '创建电站',
    电站状态: '电站状态',
    请输入电站名称: '请输入电站名称',
    查询: '查询',
    重置: '重置',
    序号: '序号',
    电站名称: '电站名称',
    系统数量: '系统数量',
    电站类型: '电站类型',
    装机功率: '装机功率',
    装机容量: '装机容量',
    电站地址: '电站地址',
    投运时间: '投运时间',
    操作: '操作',
    查看: '查看',
    修改: '修改',
    是否确认删除电站操作: '是否确认删除电站操作？',
    删除: '删除',
    暂无数据: '暂无数据',
    查看电站: '查看电站',
    基础信息: '基础信息',
    更多信息: '更多信息',
    电站图片: '电站图片',
    电站联系电话: '电站联系电话',
    安装图片: '安装图片',
    并网点信息: '并网点信息',
    有光伏: '有光伏',
    无光伏: '无光伏',
    有并网点: '有并网点',
    无并网点: '无并网点',
    其它: '其它',
    变压器信息: '变压器信息',
    站点变压器容量: '站点变压器容量',
    安装人: '安装人',
    安装人联系号码: '安装人联系号码',
    关闭: '关闭',
    全部: '全部',
    在线: '在线',
    离线: '离线',
    修改电站: '修改电站',
    '电站创建完成后，需前往系统管理，选择对应系统分配到电站后，才可正常运行': '电站创建完成后，需前往系统管理，选择对应系统分配到电站后，才可正常运行',
    创建电站后需绑定系统: '创建电站后需绑定系统',
    电站业主: '电站业主',
    请输入电站业主称呼: '请输入电站业主称呼',
    请输入电站联系电话: '请输入电站联系电话',
    请输入装机功率: '请输入装机功率',
    请输入装机容量: '请输入装机容量',
    选择日期: '选择日期',

    国家: '国家',
    省: '省',
    市: '市',
    区: '区',
    详细地址: '详细地址',
    电站经纬度: '电站经纬度',
    获取经纬度: '获取经纬度',
    经度: '经度',
    纬度: '纬度',
    重新获取: '重新获取',
    点击上传图片: '点击上传图片',
    提示: '提示',
    上传的图片大小不得超过5M支持PNGJPG格式最多可上传5张图片: '上传的图片大小不得超过5M，支持PNG、JPG格式，最多可上传 5 张图片。',
    示例说明: '示例说明',
    '请按照示例上传图片以达到更佳展示效果。（建议使用横图，主体部分位于中央区域）': '请按照示例上传图片以达到更佳展示效果。（建议使用横图，主体部分位于中央区域）',
    变压器容量: '变压器容量',
    请输入变压器容量: '请输入变压器容量',
    变压器信息: '变压器信息',
    请输入变压器信息: '请输入变压器信息',
    请选择: '请选择',
    请输入安装人称呼: '请输入安装人称呼',
    请输入安装人联系号码: '请输入安装人联系号码',
    取消: '取消',
    创建: '创建',
    经纬度: '经纬度',
    请输入地区: '请输入地区',
    确定: '确定',
    请选择电站类型: '请选择电站类型',
    装机功率数值范围大于0小于10000: '装机功率数值范围大于0小于10000',
    小数点后不允许超过3位: '小数点后不允许超过3位',
    装机容量数值范围大于0小于10000: '装机容量数值范围大于0小于10000',
    '站点变压器容量数值范围1-9999整数': '站点变压器容量数值范围1-9999整数',
    不超过200个字符: '不超过200个字符',

    未匹配到地点: '未匹配到地点！',
    未找到搜索结果: '未找到搜索结果！',
    图片大小不可超过5M: '图片大小不可超过5M',
    最多5张图片当前总数已超过请重新选择: '最多5张图片,当前总数已超过,请重新选择！',

    系统管理: '系统管理',
    请输入系统编号系统名称ems编号: '请输入系统编号/系统名称/ems编号',
    系统绑定: '系统绑定',
    主从配置: '主从配置',
    系统编号: '系统编号',
    系统名称: '系统名称',
    主从模式: '主从模式',
    主从编号: '主从编号',
    EMS编号: 'EMS编号',
    额定功率: '额定功率',
    额定容量: '额定容量',
    标称电压: '标称电压',
    统计配置: '统计配置',
    是否确认解绑: '是否确认解绑？',
    解绑: '解绑',
    共: '共',
    项数据: '项数据',
    暂无系统可点击系统绑定进行添加: '暂无系统，可点击系统绑定进行添加',
    查看系统: '查看系统',
    未知: '未知',
    主机: '主机',
    从机: '从机',
    规格参数: '规格参数',
    当前已选: '当前已选',
    项: '项',
    已选系统: '已选系统',

    冷却方式: '冷却方式',
    确认: '确认',
    暂未选择系统: '暂未选择系统',
    请确认是否绑定该系统到当前站点: '请确认是否绑定该系统到当前站点！',
    当前主从配置只针对平台展示并不会更改实际主从模式配置: '当前主从配置只针对平台展示，并不会更改实际主从模式配置。',
    输入编号: '输入编号',
    请输入: '请输入',
    暂不支持输入0: '暂不支持输入0！',
    禁止输入重复编号: '禁止输入重复编号！',

    '开启统计配置时，建议选择充放电量都为0的时间点，请先确认EMS本地能耗计已清零！': '开启统计配置时，建议选择充放电量都为0的时间点，请先确认EMS本地能耗计已清零！',
    '开启统计配置时，请先确认EMS本地能耗计已清零！': '开启统计配置时，请先确认EMS本地能耗计已清零！',
    基本信息: '基本信息',
    系统: '系统',
    时区: '时区',
    时区偏移量: '时区偏移量',
    统计状态: '统计状态',
    '当前统计未开启，请先选择统计开始时间（建议选择充放电量都为0的时间点）': '当前统计未开启，请先选择统计开始时间（建议选择充放电量都为0的时间点）',
    '请重新选择统计开始时间（建议选择充放电量都为0的时间点）': '请重新选择统计开始时间（建议选择充放电量都为0的时间点）',
    已开启: '已开启',
    统计开始时间: '统计开始时间',
    选择日期时间: '选择日期时间',
    上次选择时间: '上次选择时间',
    重新选择: '重新选择',

    原始数据: '原始数据',
    时间范围: '时间范围',
    开始时间: '开始时间',
    结束时间: '结束时间',
    最多支持查看7日范围的数据: '最多支持查看7日范围的数据',
    '请确认是否开启统计？': '请确认是否开启统计？',
    '开启统计后，平台将按照设置的“统计开始时间”进行统计！': '开启统计后，平台将按照设置的“统计开始时间”进行统计！',
    '请确认是否变更统计开始时间？': '请确认是否变更统计开始时间？',
    '变更后，平台将按照新设置的时间进行重新统计！': '变更后，平台将按照新设置的时间进行重新统计！',
    充电: '充电',
    放电: '放电',
    电量kWh: '电量/kWh',
    '时间范围只能选择1-7天': '时间范围只能选择1-7天',
    请选择统计开始时间: '请选择统计开始时间',
    统计开始时间未变更: '统计开始时间未变更',
    '开启统计时间失败!': '开启统计时间失败!'
  }
}
export default poStaManageZh
